<template>
    <div class="list_item" @click="goDetailPage">
        <!-- IMAGE start -->
        <div class="item_cell cell image_cell">
            <div class="image_container">
                <img-box
                    class="image"
                    :src="cellData.previewPicture"
                    :errorImg="errorImg"
                    :alt="$ft.formatAddr(cellData.address)"
                >
                </img-box>
                <div class="amount_container">
                    <span class="iconfont icon-new-photo"></span>
                    <span class="amount">{{ cellData.picturesNum }}</span>
                </div>
                <VerifyMask v-if="isShowMask" />
            </div>
        </div>
        <!-- IMAGE end  -->
        <!-- Address  start -->
        <div class="item_cell cell">
            <div class="address">
                <a :href="cellData.link" rel="noopener noreferrer">{{
                    !isShowMask ? $ft.formatAddr(cellData.address) : $t('addressNotDisclosed')
                }}</a>
            </div>
        </div>
        <!-- Address end -->
        <!-- Sold PRICE start -->
        <div class="item_cell cell">
            <div class="sold_price" v-if="!isShowMask">
                <template v-if="showPrice">
                    <div class="price">
                        {{
                            $ft.formatUnitNum(
                                cellData.showPrice,
                                false,
                                0,
                                currencySymbol
                            )
                        }}
                    </div>
                    <div
                        class="tendency"
                        :class="{
                            up: cellData.status > 0,
                            down: cellData.status < 0
                        }"
                    >
                        <div class="icon_container" v-if="cellData.status !== 0">
                            <div class="icon">
                                <span class="iconfont icon-expand"></span>
                            </div>
                            <span>{{ changePriceNum }}</span>
                        </div>
                    </div>
                </template>
                <div v-else class="empty-price">--</div>
            </div>
            <PriceMask v-else />
        </div>
        <!-- Sold PRICE end -->
        <!-- Sold Date start -->
        <div class="item_cell cell">
            <only-client>
                <span class="text_common">{{
                    $ft.formatDate(new Date(cellData.listDate), 'MM/dd/yyyy')
                }}</span>
            </only-client>
        </div>
        <!-- Sold Date end -->
        <!-- CONFIGURE start -->
        <div class="item_cell cell">
            <div class="text_common">
                <div>
                    {{
                        $t('md-listing-list.bed0', { count: !isShowMask ? cellData.bedrooms : '***' })
                    }}
                </div>
                <div>
                    {{
                        $t('md-listing-list.bath0', {
                            count: !isShowMask ? cellData.bathrooms : '***'
                        })
                    }}
                </div>
                <div>{{ !isShowMask ? cellData.sqft : '*** ' + $t('md-listing-list.sqft') }}</div>
            </div>
        </div>
        <!-- CONFIGURE end -->
        <!-- Property Type start -->
        <div class="item_cell cell t_right">
            <span class="text_common text_no_wrap">{{
                cellData.propertyType
            }}</span>
        </div>
        <!-- Property Type end -->
    </div>
</template>

<script>
import common from '../../../_mixins/table-item/common';
export default {
    name: 'table-item',
    mixins: [common]
};
</script>

<style lang="scss">
.list-table-pc.template4{
    .list_item {
        cursor: pointer;
    }
    /* item_cell  The style settings under  start */
    .item_cell {
        padding: 10px 0;
        border-bottom: 1px solid var(--color-border);
        height: 100%;
        vertical-align: middle;
        &.image_cell {
            border-bottom-color: transparent;
        }
        &.cell {
            display: table-cell;
        }
        .image_container {
            width: 200px;
            height: 130px;
            position: relative;
            .image {
                width: 100%;
                height: 100%;
            }
            .amount_container {
                position: absolute;
                top: 0;
                right: 0;
                height: 30px;
                width: 50px;
                color: #fff;
                font-size: 14px;
                background: rgba(0, 0, 0, 0.2);
                border-bottom-left-radius: 6px;
                display: flex;
                align-items: center;
                justify-content: center;
                .amount {
                    margin-left: 7px;
        
                }
            }
        }
        .address {
            padding-right: 30px;
            word-break: break-word;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-word;
            font-size: 16px;
            line-height: 1.5;
            color: var(--color-title);
            a:hover {
                text-decoration: underline;
            }
        }
        .text_common {
            font-size: 14px;
            line-height: 20px;
            color: var(--color-label);
            white-space: nowrap;
            &.text_no_wrap {
                white-space: pre-wrap;
            }
        }
        .sold_price {
            .price {
                font-size: 20px;
                font-weight: bold;
                line-height: 1.25;
                color: var(--color-text);
                margin-bottom: 6px;
            }
            .tendency {
                font-size: 14px;
                font-weight: bold;
                .icon_container {
                    display: flex;
                    align-items: center;
                }
                &.up {
                    color: #96efb4;
                    .icon {
                        transform: rotate(180deg);
                    }
                }
                &.down {
                    color: #ffb8b4;
                }
            }
            .empty-price{
                text-align: left;
            }
        }
    }
    /* item_cell  The style settings under  end */
    .t_right {
        text-align: right;
    }
}
</style>
